<template>
  <div class="point">
    <Header></Header>
    <div class="banner">
      <img src="../assets/images/banner2.png" alt="">
    </div>
    <div class="advertisement">
       <img src="../assets/images/ad.png" alt="">
    </div>
    <div class="order">
      <div class="order-point">
        <div
          class="order-point-row space-between"
          :style="showRest?'':'margin-bottom:5px'"
          @click="tapShowRest"
        >
          <div class="color333">剩余积分:{{childInfo.integral}}</div>
          <div class="color-green" v-if="showRest">
            展开
            <img src="../assets/images/arrow-down2.png" />
          </div>
          <div class="color-green" v-else>
            折叠
            <img src="../assets/images/arrow-up.png" />
          </div>
        </div>
        <div v-if="showRest">
          <div class="order-point-row color666">购买积分:{{childInfo.buyIntegral}}</div>
          <div class="order-point-row color666">任务积分:{{childInfo.taskIntegral}}</div>
        </div>
      </div>
      <div class="order-pay">
        <div class="order-title space-between">
          <div class="color333">积分充值</div>
          <div class="color-green">购买积分记录>></div>
        </div>
        <div class="order-list">
          <div
            class="order-list-item"
            :class="activeIndex==index?'active':''"
            v-for="(item,index) in orderList"
            @click="pay(item.orderMoney,item.point,index)"
            :key="index"
          >
            <img src="../assets/images/tuijian.png" />
            <div>{{item.point}}积分</div>
            <div>售价{{item.showMoney}}元</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "../components/Header";
export default {
  name:'points',
  data() {
    return {
      activeIndex: -1,
      showRest: false,
      orderList: [
        {
          showMoney: 10.0,
          orderMoney: 0.01,
          point: 100
        },
        {
          showMoney: 20.0,
          orderMoney: 20,
          point: 200
        },
        {
          showMoney: 50.0,
          orderMoney: 50,
          point: 500
        },
        {
          showMoney: 100.0,
          orderMoney: 100,
          point: 1000
        }
      ]
    };
  },
 computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo:state => state.activeChildInfo
    }),
  },
  components:{
    Header
  },
  methods: {
    pay(monkey,integral,idx) {
      
      this.activeIndex=idx;      
      let params = {
        childId:JSON.parse(localStorage.getItem('activeChildInfo')).id,
        childName: JSON.parse(localStorage.getItem('activeChildInfo')).name,
        couponMoney: 0,
        integral: integral,
        openId: JSON.parse(localStorage.getItem('userInfo')).openId,
        orderDetail: "充值" +monkey + "元",
        orderMoney: monkey,
        payMoney:monkey
      };
      console.log(params);
      api.miniPay(params).then(res => {
        console.log(res);
        wx.requestPayment({
          timeStamp: res.data.data.timeStamp,
          nonceStr: res.data.data.nonceStr,
          package: res.data.data.packAge,
          signType: res.data.data.signType,
          paySign: res.data.data.paySign,
          success(res) {
            if (res.errMsg == "requestPayment:ok") {
              console.log(res);
            } else {
            }
          },
          fail(res) {}
        });
      });
    },
    tapShowRest() {
      this.showRest=!this.showRest
    }
  }
};
</script>
<style scoped lang="less">
.point{
    background: #EDF0F4;
    height: 100vh;
}
.banner{
 padding-top: 6px;
}
.advertisement{
  padding:0 15px;
  margin: 5px 0 10px 0;
  img{
    width: 100%;
  }
}
.order{
  width: 325px;
  margin: 0 auto;
  background: #fff;
  padding: 0 10px
}
.order-point{
  border-bottom: 1rpx solid #EEEEEE;
  padding: 5px 10px 0 10px
}
.order-point-row{
  line-height: 30px
}
.order-point-row img{
  width: 15px;
  height: 7px
}
.order-title{
  padding: 10px 10px 15px 10px
}
.order-list-item{
  width: 140px;
  display: inline-block;
  margin-left: 15px;
  padding: 15px 0;
  text-align: center;
  border-radius:4px;
  background: #fff;
  color: #87E2CD;
  border:1px solid #87E2CD;
  margin-bottom: 15px;
  position: relative
}
.order-list-item img{
  position: absolute;
  top: 0;
  left: 0;
  width: 36px;
  height: 36px;
}
.order-list .active{
  background:linear-gradient(180deg,rgba(186,239,229,1) 0%,rgba(127,218,197,1) 100%);
  color: #fff;
}
</style>